import { isAxiosError } from "axios";

// Durante un rilascio il reverse proxy risponde 503 a ogni richiesta su /api/*
// con `Retry-After` e il corpo `{"error":"MAINTENANCE"}` (avviso backend
// 2026-09-11-web-admin-delta-503-maintenance-and-version). Il backend non vede
// quelle richieste: il corpo NON è l'envelope `{errorCode}` di ErrorResponse,
// per questo `mapBackendError` non lo riconosce e serve un riconoscimento a parte.

/** Il valore che il proxy manda oggi; vale quando l'header manca o non si legge. */
export const DEFAULT_RETRY_AFTER_SECONDS: number = 120;

/**
 * Secondi dopo cui ritentare se l'errore è un 503 di manutenzione, altrimenti null.
 * `Retry-After` può essere un numero di secondi o una data HTTP.
 */
export function maintenanceRetryAfter(error: unknown): number | null {
  if (!isAxiosError(error)) return null;
  const response = error.response;
  if (response?.status !== 503) return null;
  const body = response.data as { error?: unknown } | undefined;
  if (typeof body !== "object" || body?.error !== "MAINTENANCE") return null;

  const header: unknown = response.headers?.["retry-after"];
  if (typeof header !== "string" || header.trim() === "") return DEFAULT_RETRY_AFTER_SECONDS;
  const seconds: number = Number(header);
  if (Number.isFinite(seconds) && seconds >= 0) return seconds;
  const date: number = Date.parse(header);
  if (Number.isNaN(date)) return DEFAULT_RETRY_AFTER_SECONDS;
  return Math.max(0, Math.round((date - Date.now()) / 1000));
}

/** Minuti interi da mostrare all'utente, arrotondati per eccesso e mai sotto uno. */
export function maintenanceMinutes(seconds: number): number {
  return Math.max(1, Math.ceil(seconds / 60));
}
